import type { AlignmentConfig } from '@editor/components/Controls/IFCUploadWidget/types/ifcMetadata'
import { AlignmentFormValues } from './types'

const ZERO_POINT = { x: 0, y: 0, z: 0 }

export function alignmentConfigToDefaultValues(
  config: AlignmentConfig | undefined,
): AlignmentFormValues {
  if (!config) {
    return {
      referencePointIFCCS: ZERO_POINT,
      referencePointModelCS: ZERO_POINT,
      zRotationDegrees: 0,
    }
  }
  const ifcCs = config.referencePointIFCCS ?? [0, 0, 0]
  const modelCs = config.referencePointModelCS ?? [0, 0, 0]
  const [ix, iy, iz] = ifcCs
  const [mx, my, mz] = modelCs
  const zDeg = config.zRotationDegrees ?? 0
  return {
    referencePointIFCCS: { x: ix, y: iy, z: iz },
    referencePointModelCS: { x: mx, y: my, z: mz },
    zRotationDegrees: Number(zDeg) || 0,
  }
}

export function formValuesToAlignmentConfig(values: AlignmentFormValues): AlignmentConfig {
  return {
    referencePointIFCCS: [
      values.referencePointIFCCS.x,
      values.referencePointIFCCS.y,
      values.referencePointIFCCS.z,
    ],
    referencePointModelCS: [
      values.referencePointModelCS.x,
      values.referencePointModelCS.y,
      values.referencePointModelCS.z,
    ],
    zRotationDegrees: Number(values.zRotationDegrees) || 0,
  }
}
